import { Badge, Text, Tooltip, VStack } from "@chakra-ui/react";

interface InfoFieldProps {
  title: string;
  value: string | React.ReactNode;
  colorScheme?: string;
}

const InfoField = ({ title, value, colorScheme = "gray" }: InfoFieldProps) => {
  return (
    <VStack
      // w="full"
      alignItems={"flex-start"}
      spacing={1}
      flexShrink={0}
      justifyContent={"flex-start"}
    >
      <Text fontWeight={"medium"} fontSize="sm" color="gray.500">
        {title}
      </Text>
      <Tooltip label={value}>
        <Badge
          fontWeight={"medium"}
          colorScheme={colorScheme}
          noOfLines={1}
          maxW={["100px", "200px"]}
        >
          {value}
        </Badge>
      </Tooltip>
    </VStack>
  );
};

export default InfoField;
